import Tooltip from './tooltip';

export { type TooltipProps } from './tooltip';

export default Tooltip;
